import { type NextPage, type InferGetStaticPropsType } from "next";
import Layout from "@components/Layout";
import Pagination, { usePagination } from "@components/Pagination";
import { getAllSpeciali } from "~/lib/db/speciali";
import SpecialiComponent from "~/components/SpecialiComponent";
import React from "react";
import { ISSUES_TYPE } from "~/types";
import Masonry from "react-masonry-css";

const DEFAULT_ITEMS_PER_PAGE = 24;
const breakpointColumnsObj = {
  default: 3,
  1280: 2,
  768: 1,
};

const Speciali: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  allSpeciali,
}) => {
  const allSpecialiShow = usePagination(allSpeciali, DEFAULT_ITEMS_PER_PAGE);
  const items = allSpecialiShow.map((el, index) => {
    return {
      id: index,
      item: {
        term: el,
      },
    };
  });
  return (
    <>
      <Layout title="Speciali">
        <div className="mb-32 ml-auto mr-auto max-w-box px-4">
          <h1 className="inline-block py-1 text-5xl font-light text-black">
            Speciali
          </h1>
        </div>
        <div className="mx-auto mt-0 max-w-box px-4">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="flex gap-20"
            columnClassName="flex flex-col gap-20"
          >
            {items.map((item, index) => (
              <SpecialiComponent
                key={index}
                data={item}
                tax={ISSUES_TYPE.speciali}
              />
            ))}
          </Masonry>
        </div>
        <div
          className={`mx-auto mt-6 max-w-box px-4 text-center ${
            allSpeciali.length > DEFAULT_ITEMS_PER_PAGE ? "" : "hidden"
          }`}
        >
          <Pagination
            totalResults={allSpeciali.length}
            itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
          />
        </div>
      </Layout>
    </>
  );
};

export default Speciali;

export const getStaticProps = async () => {
  const allSpeciali = await getAllSpeciali();
  return {
    props: {
      allSpeciali: allSpeciali,
    },
    revalidate: 20 * 60,
  };
};
